import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServiciosOpen, setIsServiciosOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Servicios', path: '/servicios', hasSubmenu: true },
    { name: 'Proyectos', path: '/proyectos' },
    { name: 'Contacto', path: '/contacto' },
  ];

  const serviciosSubmenu = [
    { name: 'Hormigón Impreso', path: '/servicios/hormigon-impreso' },
    { name: 'Hormigón Desactivado', path: '/servicios/hormigon-desactivado' },
    { name: 'Hormigón Pulido', path: '/servicios/hormigon-pulido' },
    { name: 'Hormigón Rallado', path: '/servicios/hormigon-rallado' },
    { name: 'Piscinas Arelite', path: '/servicios/piscinas-arelite' },
    { name: 'Protecciones de Acabados', path: '/servicios/protecciones-acabados' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/5fa39b647fe9b9756d6d13910558d3e0/22dc4b37e72a444c4964897dd25d2553.png" 
              alt="HORMI PREMIUM - Hormigón Decorativo" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <div key={link.path} className="relative group">
                {link.hasSubmenu ? (
                  <div>
                    <Link
                      to={link.path}
                      className={`font-medium transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1 ${
                        isActive(link.path) || location.pathname.startsWith('/servicios')
                          ? 'text-[#1E90FF]'
                          : 'text-gray-700 hover:text-[#1E90FF]'
                      }`}
                    >
                      {link.name}
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-down-s-line text-lg"></i>
                      </div>
                    </Link>
                    
                    <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl py-2 border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                      {serviciosSubmenu.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          className={`block px-4 py-2.5 text-sm transition-colors cursor-pointer ${
                            isActive(item.path)
                              ? 'text-[#1E90FF] bg-blue-50'
                              : 'text-gray-700 hover:text-[#1E90FF] hover:bg-gray-50'
                          }`}
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link
                    to={link.path}
                    className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                      isActive(link.path)
                        ? 'text-[#1E90FF]'
                        : 'text-gray-700 hover:text-[#1E90FF]'
                    }`}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Desktop Contact Info */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+34640877479"
              className="flex items-center gap-2 text-gray-700 hover:text-[#1E90FF] transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg"></i>
              </div>
              <span className="font-medium">640 877 479</span>
            </a>
            <a
              href="#presupuesto"
              className="px-6 py-2.5 bg-[#1E90FF] text-white rounded-full font-medium hover:bg-[#1873CC] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
            >
              Presupuesto Gratis
            </a>
          </div>

          {/* Mobile Actions - Phone & CTA Button */}
          <div className="md:hidden flex items-center gap-2">
            <a
              href="tel:+34640877479"
              className="w-10 h-10 flex items-center justify-center text-[#1E90FF] hover:bg-gray-50 rounded-full transition-colors cursor-pointer"
              aria-label="Llamar"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-xl"></i>
              </div>
            </a>
            
            <a
              href="#presupuesto"
              className="px-4 py-2 bg-[#1E90FF] text-white rounded-full text-sm font-medium hover:bg-[#1873CC] transition-colors cursor-pointer whitespace-nowrap"
            >
              Presupuesto
            </a>
            
            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer ml-1"
              aria-label="Toggle menu"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <div key={link.path}>
                  <Link
                    to={link.path}
                    onClick={() => !link.hasSubmenu && setIsMenuOpen(false)}
                    className={`font-medium transition-colors cursor-pointer py-2 flex items-center justify-between ${
                      isActive(link.path) || (link.hasSubmenu && location.pathname.startsWith('/servicios'))
                        ? 'text-[#1E90FF]'
                        : 'text-gray-700 hover:text-[#1E90FF]'
                    }`}
                  >
                    {link.name}
                    {link.hasSubmenu && (
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-arrow-down-s-line text-lg"></i>
                      </div>
                    )}
                  </Link>
                  
                  {link.hasSubmenu && (
                    <div className="ml-4 mt-2 space-y-2">
                      {serviciosSubmenu.map((item) => (
                        <Link
                          key={item.path}
                          to={item.path}
                          onClick={() => setIsMenuOpen(false)}
                          className={`block py-2 text-sm transition-colors cursor-pointer ${
                            isActive(item.path)
                              ? 'text-[#1E90FF] font-medium'
                              : 'text-gray-600 hover:text-[#1E90FF]'
                          }`}
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              
              <div className="border-t border-gray-100 pt-4 mt-2 space-y-3">
                <a
                  href="https://wa.me/34640877479"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 py-3 px-4 bg-[#25D366] text-white rounded-lg hover:bg-[#20BA5A] transition-colors cursor-pointer font-medium"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-fill text-xl"></i>
                  </div>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
